import Forward from "@/views/Forward.vue";

export default (rootPath) => {
  return [
    {
      path: "",
      component: Forward,
      redirect: `${rootPath}/list`,
      hidden: true,
      children: [
        {
          path: "list",
          component: () => import("@/views/table/MaterialsTable.vue"),
          meta: { title: "Список материалов", activeMenuParent: true },
          hidden: true,
        },
        {
          path: "create",
          component: () => import("@/views/forms/MaterialsForm.vue"),
          meta: { title: "Создать материал", activeMenuParent: true },
          hidden: true,
        },
        {
          path: "edit/:id",
          component: () => import("@/views/forms/MaterialsForm.vue"),
          meta: {
            title: "Редактировать материал",
            activeMenuParent: true,
          },
          hidden: true,
        },
      ],
    },
  ];
};
